import { render } from "./ShopVIP.vue?vue&type=template&id=018113d4&scoped=true"
import script from "./ShopVIP.vue?vue&type=script&lang=js"
export * from "./ShopVIP.vue?vue&type=script&lang=js"

import "./ShopVIP.vue?vue&type=style&index=0&id=018113d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018113d4"]])

export default __exports__